import React, { useState } from 'react';
import { Button } from 'react-admin';
import { getMyQr2FaCode, getWebAuthnFaCode } from '../../Services/users';
import { QRCodeSVG } from 'qrcode.react';
import {
	Card,
	CardContent,
	CardActions,
	Container,
	Grid,
	Typography,
} from '@mui/material';
import { WebAuthnLogin } from '../../Components/TwoFa/Webauthn';

const base64ToArrayBuffer = (b64: string): ArrayBuffer => {
	const binaryString = window.atob(b64.replace(/-/g, '+').replace(/_/g, '/'));
	const bytes = new Uint8Array(binaryString.length);
	for (let i = 0; i < binaryString.length; i++) {
		bytes[i] = binaryString.charCodeAt(i);
	}
	return bytes.buffer;
};

export const TwoFa = () => {
	const [qrUrl, setQrUrl] = useState<string | null>(null);
	const [webAuthnStatus, setWebAuthnStatus] = useState<boolean>(false);

	const handleTwoFaQRCode = async () => {
		if (
			window.confirm(
				'Êtes-vous sûr de vouloir générer un nouveau QR Code ? Cela invalidera l’ancien.'
			)
		) {
			try {
				const url = await getMyQr2FaCode();
				setQrUrl(url.url);
			} catch (error) {
				console.error('Error fetching 2FA QR code:', error);
			}
		}
	};
	const handleWebAuthnSetup = async () => {
		try {
			const options = await getWebAuthnFaCode();

			// console.log('WebAuthn options:', options);

			// Corriger les encodages base64 vers ArrayBuffer
			options.publicKey.challenge = base64ToArrayBuffer(
				//@ts-ignore
				options.publicKey.challenge
			);
			options.publicKey.user.id = base64ToArrayBuffer(
				//@ts-ignore
				options.publicKey.user.id
			);

			setWebAuthnStatus(true);
		} catch (err: any) {
			alert('Erreur WebAuthn : ' + err.message);
		}
	};

	return (
		<Container maxWidth="md" style={{ marginTop: '2rem' }}>
			<Typography variant="h4" gutterBottom>
				Activer la double authentification (2FA)
			</Typography>
			<Typography variant="subtitle1" color="textSecondary" gutterBottom>
				Choisissez une méthode pour renforcer la sécurité de votre compte.
			</Typography>

			<Grid container spacing={3} style={{ marginTop: '1rem' }}>
				<Grid item xs={12}>
					<Card>
						<CardContent>
							<Typography variant="h6">
								Application d’authentification
							</Typography>
							<Typography variant="body2" color="textSecondary">
								Utilisez Google Authenticator, 1Password, ou autre pour générer
								un code temporaire.{' '}
								<strong>
									Attention : si vous avez déjà configuré un QR code, il
									deviendra invalide. Pensez à le remplacer dans votre
									application d’authentification.
								</strong>
							</Typography>
						</CardContent>
						<CardActions
							style={{ justifyContent: 'flex-end', paddingRight: '1.5rem' }}
						>
							<Button label="Obtenir mon QR Code" onClick={handleTwoFaQRCode} />
						</CardActions>
					</Card>
				</Grid>

				<Grid item xs={12}>
					<Card>
						<CardContent>
							<Typography variant="h6">Clé de sécurité (WebAuthn)</Typography>
							<Typography variant="body2" color="textSecondary">
								Utilisez une clé physique (Yubikey, biométrie) pour sécuriser
								votre compte.
							</Typography>
						</CardContent>
						<CardActions
							style={{ justifyContent: 'flex-end', paddingRight: '1.5rem' }}
						>
							<Button label="Configurer" onClick={handleWebAuthnSetup} />
							{webAuthnStatus && <WebAuthnLogin />}
						</CardActions>
					</Card>
				</Grid>
			</Grid>

			{qrUrl && (
				<Card style={{ marginTop: '2rem' }}>
					<CardContent style={{ textAlign: 'center' }}>
						<Typography variant="subtitle1" gutterBottom>
							Scannez ce QR Code dans votre application
						</Typography>
						<QRCodeSVG value={qrUrl} size={200} />
						<Typography
							variant="body2"
							color="textSecondary"
							style={{ marginTop: '1rem', wordBreak: 'break-all' }}
						>
							{qrUrl}
						</Typography>
					</CardContent>
				</Card>
			)}
		</Container>
	);
};
